import { defineStyle } from "@chakra-ui/react";

import { Input } from "./input";

export const CreditCardInput = defineStyle({
  baseStyle: {
    maxWidth: "400px",
    display: "grid",
    gridTemplateColumns: "1fr",
    alignContent: "center",
    "& .StripeElement": {
      outline: "none",
      border: "1px solid",
      position: "relative",
      padding: "10px 8px 8px 8px",
      ...Input.variants?.outline.field,
    },
    "& .StripeElement--empty": {
      outline: "none",
    },
    "& .StripeElement--focus": {
      ...Input.variants?.outline.field._focus,
    },
    "& .StripeElement--complete": {
      ...Input.variants?.outline.field._focus,
    },
    "& .StripeElement--invalid": {
      outline: "none",
      ...Input.variants?.outline.field._invalid,
    },
    "& .CardField-expiry .InputElement::placeholder": {
      textTransform: "lowercase",
    },
  },
});
